export default __webpack_public_path__ + "static/2003mobile-9278ec2bab2d1d1c7966f92a4babd58f.png";